import type { JSX } from 'react'
import type {
  FallbackImageBackgroundColors,
  FallbackImageBorderColors,
  FallbackImageBorders,
} from './FallbackImage.h'

import { Icon } from 'atoms/Icon'
import { COLOR } from 'vars/color'
import { FALLBACK_IMAGES } from 'vars/fallback-images'
import { FallbackImageSizes } from './FallbackImage.h'
import { FallbackImageSC } from './FallbackImage.styled'

export interface IFallbackImageProps {
  icon?: (typeof FALLBACK_IMAGES)[keyof typeof FALLBACK_IMAGES]
  size?: FallbackImageSizes
  color?: string
  borders?: FallbackImageBorders
  borderColor?: FallbackImageBorderColors
  background?: FallbackImageBackgroundColors | COLOR
}

export const FallbackImage = ({
  icon = FALLBACK_IMAGES.DEFAULT,
  size = FallbackImageSizes.M,
  color = COLOR.DISABLED,
  borders,
  borderColor,
  background,
}: IFallbackImageProps): JSX.Element => (
  <FallbackImageSC
    size={FallbackImageSizes[size]}
    color={color}
    borders={borders}
    borderColor={borderColor}
    background={background}
  >
    <Icon name={icon} size={size} color={color} />
  </FallbackImageSC>
)
